module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Miso-soup-49a6c366ebe880dbad76035ac1dea397.svg";